import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { Nav } from "@themesberg/react-bootstrap";

import { Routes } from "../../../routes";
import SepaySettings from "./SepaySettings";
import SepayTransactionList from "./SepayTransactionList";

const TABS = [
  { key: "settings", label: "Cấu hình SePay" },
  { key: "transactions", label: "Lịch sử webhook" },
];

export default () => {
  const location = useLocation();
  const [tab, setTab] = useState(
    location.pathname === Routes.SettingSePayTransactions.path
      ? "transactions"
      : "settings"
  );

  return (
    <>
      <Nav
        variant="tabs"
        className="mb-3 mt-3"
        activeKey={tab}
        onSelect={(k) => setTab(k)}
      >
        {TABS.map((t) => (
          <Nav.Item key={t.key}>
            <Nav.Link eventKey={t.key}>{t.label}</Nav.Link>
          </Nav.Item>
        ))}
      </Nav>

      {tab === "settings" ? <SepaySettings /> : <SepayTransactionList />}
    </>
  );
};
